import {
    CREATE_CHECKING_DC_INWARD_DETAILS_REQUEST,
    CREATE_CHECKING_DC_INWARD_DETAILS_SUCCESS,
    CREATE_CHECKING_DC_INWARD_DETAILS_FAILURE,
    DELETE_CHECKING_DC_INWARD_DETAILS_REQUEST,
    DELETE_CHECKING_DC_INWARD_DETAILS_SUCCESS,
    DELETE_CHECKING_DC_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_FAILURE,
    FETCH_CHECKING_DC_INWARD_DETAILS_REQUEST,
    FETCH_CHECKING_DC_INWARD_DETAILS_SUCCESS,
    FETCH_CHECKING_DC_INWARD_DETAILS_FAILURE,
    UPDATE_CHECKING_DC_INWARD_DETAILS_REQUEST,
    UPDATE_CHECKING_DC_INWARD_DETAILS_SUCCESS,
    UPDATE_CHECKING_DC_INWARD_DETAILS_FAILURE,
    RESET_CHECKING_DC_INWARD_DETAILS_INFO,
    CREATE_CHECKING_DC_INWARD_DETAILS_FORM,
    UPDATE_CHECKING_DC_INWARD_DETAILS_FORM,
    FETCH_CHECKING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS
} from './checkingDcInwardDetails.actionsType';

export const CHECKING_DC_INWARD_DETAILS = 'checkingDcInwardDetails';

let initialState = {
    loading: false,
    checkingDcInwardDetails: [],
    checkingDcInwardDetailsWithoutId: [],
    checkingDcInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let checkingDcInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CHECKING_DC_INWARD_DETAILS_REQUEST:
        case CREATE_CHECKING_DC_INWARD_DETAILS_REQUEST:
        case UPDATE_CHECKING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_REQUEST:
        case DELETE_CHECKING_DC_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CHECKING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardDetails: updatePayload
            };
        case FETCH_CHECKING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardDetailsWithoutId: updatePayload
            };
        case CREATE_CHECKING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case UPDATE_CHECKING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardDetailsForm: updatePayload
            };
        case DELETE_CHECKING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case RESET_CHECKING_DC_INWARD_DETAILS_INFO:
            return {
                ...state,
                checkingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case CREATE_CHECKING_DC_INWARD_DETAILS_FORM:
        case UPDATE_CHECKING_DC_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                checkingDcInwardDetailsForm: {
                    ...state.checkingDcInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_CHECKING_DC_INWARD_DETAILS_FAILURE:
        case CREATE_CHECKING_DC_INWARD_DETAILS_FAILURE:
        case UPDATE_CHECKING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_CHECKING_DC_INWARD_DETAILS_FAILURE:
        case DELETE_CHECKING_DC_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
